/* Zaccha — scroll reveal + count-up.
   [data-zh-reveal]  -> adds .zh-in as it enters the viewport (CSS does the motion).
   [data-zh-countup] -> animates its number 0 -> target (keeps prefix/suffix).
   Honors prefers-reduced-motion and the theme editor (instant, no motion). No-JS safe. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design = window.Shopify && window.Shopify.designMode;
  var noIO = !('IntersectionObserver' in window);
  var instant = reduce || design || noIO;

  function show(el) {
    var d = parseInt(el.getAttribute('data-zh-delay') || '0', 10);
    if (d) { el.style.transitionDelay = d + 'ms'; }
    el.classList.add('zh-in');
  }

  // ---- count-up ----
  function parse(str) {
    var m = String(str).match(/^(\D*)([\d,.]+)(.*)$/);
    if (!m) return null;
    var num = m[2].replace(/,/g, '');
    return { prefix: m[1], target: parseFloat(num), decimals: (num.split('.')[1] || '').length, suffix: m[3] };
  }
  function fmt(n, d) { return n.toLocaleString(undefined, { minimumFractionDigits: d, maximumFractionDigits: d }); }
  function setNum(el, info, n) { el.textContent = info.prefix + fmt(n, info.decimals) + info.suffix; }
  function countUp(el) {
    var info = el._zhInfo;
    if (!info) return;
    // Use extra decimals while animating so small targets (e.g. 1 in "1M+") still climb smoothly.
    var animDec = info.decimals;
    while (info.target * Math.pow(10, animDec) < 18 && animDec < 3) { animDec++; }
    var dur = 2400, t0 = (performance || Date).now();
    function render(n, d) { el.textContent = info.prefix + fmt(n, d) + info.suffix; }
    function step(now) {
      var p = Math.min((now - t0) / dur, 1), e = 1 - Math.pow(1 - p, 3);
      if (p < 1) { render(info.target * e, animDec); requestAnimationFrame(step); }
      else { render(info.target, info.decimals); }
    }
    requestAnimationFrame(step);
  }

  function init(root) {
    root = root || document;
    var reveals = root.querySelectorAll('[data-zh-reveal]:not(.zh-in)');
    var counts = root.querySelectorAll('[data-zh-countup]:not([data-zh-counted])');

    // Prep count-ups: remember the target, zero them out only if we're going to animate.
    counts.forEach(function (el) {
      var info = parse(el.textContent);
      if (!info) { el.setAttribute('data-zh-counted', '1'); return; }
      el._zhInfo = info;
      if (!instant) { setNum(el, info, 0); }
    });

    if (instant) {
      reveals.forEach(function (e) { e.classList.add('zh-in'); });
      counts.forEach(function (e) { e.setAttribute('data-zh-counted', '1'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        if (el.hasAttribute('data-zh-reveal')) { show(el); }
        if (el.hasAttribute('data-zh-countup') && !el.hasAttribute('data-zh-counted')) {
          el.setAttribute('data-zh-counted', '1');
          countUp(el);
        }
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.2 });

    reveals.forEach(function (e) { io.observe(e); });
    counts.forEach(function (e) { io.observe(e); });
  }

  if (document.readyState !== 'loading') { init(); }
  else { document.addEventListener('DOMContentLoaded', function () { init(); }); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target || document); });
})();
